import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="hero-carousel"
export default class extends Controller {
  static targets = ["slide", "dot"];

  connect() {
    this.currentIndex = 0;
    this.interval = setInterval(() => this.next(), 5000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  next() {
    this.goToSlide((this.currentIndex + 1) % this.slideTargets.length);
  }

  goTo(event) {
    clearInterval(this.interval);
    this.goToSlide(parseInt(event.currentTarget.dataset.index));
    this.interval = setInterval(() => this.next(), 5000);
  }

  goToSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("opacity-0", i !== index);
    });
    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("bg-white", i === index);
      dot.classList.toggle("bg-white/40", i !== index);
    });
    this.currentIndex = index;
  }
}
